export default "__VITE_ASSET__tsxhJDIf__"